import { useEffect, useState } from 'react';
import { FiMoreVertical } from 'react-icons/fi';
import styles from './Dashboard.module.css';
import StatusBadge from '../../components/StatusBadge/StatusBadge';
import SearchInput from '../../components/SearchInput/SearchInput';
import StatCard from '../../components/StatCard/StatCard';
import { api, mapAdminOrder, money } from '../../lib/api';

function compactMoney(value) {
    const n = Number(value) || 0;
    if (n >= 1000) return `K${(n / 1000).toFixed(1)}k`;
    return money(n);
}

const Dashboard = () => {
    const [search, setSearch] = useState('');
    const [stats, setStats] = useState([]);
    const [orders, setOrders] = useState([]);

    useEffect(() => {
        api('/admin/stats')
            .then((s) => {
                setStats([
                    { value: String(s.users).padStart(2, '0'), label: 'Users' },
                    { value: String(s.liveListings).padStart(2, '0'), label: 'Live listings' },
                    { value: String(s.openNegotiations).padStart(2, '0'), label: 'Open negotiations' },
                    { value: compactMoney(s.gmv), label: 'Order value (GMV)' },
                ]);
                setOrders((s.recentOrders || []).map(mapAdminOrder));
            })
            .catch(() => {});
    }, []);

    const filteredOrders = orders.filter((order) => {
        const query = search.toLowerCase();
        return (
            order.id.toLowerCase().includes(query) ||
            order.buyer.toLowerCase().includes(query) ||
            order.item.toLowerCase().includes(query)
        );
    });

    return (
        <div>
            <div className="row g-3">
                {stats.map(({ value, label }) => (
                    <div key={label} className="col-12 col-sm-6 col-xl-3">
                        <StatCard value={value} label={label} />
                    </div>
                ))}
            </div>

            <div className={`${styles.tableCard} mt-4 p-4`}>
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                    <h2 className={`${styles.tableTitle} mb-0`}>Recent orders</h2>

                    <SearchInput
                        className={styles.orderSearch}
                        placeholder="Search for equipments, produce..."
                        value={search}
                        onChange={(event) => setSearch(event.target.value)}
                    />
                </div>

                <div className={`${styles.tableWrap} table-responsive mt-3`}>
                    <table className={`${styles.table} w-100`}>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Buyer</th>
                                <th>Item</th>
                                <th>Total</th>
                                <th>Status</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredOrders.map((order) => (
                                <tr key={order.id}>
                                    <td className={styles.orderId}>{order.id}</td>
                                    <td>{order.buyer}</td>
                                    <td>{order.item}</td>
                                    <td className={styles.orderTotal}>{order.total}</td>
                                    <td><StatusBadge status={order.status} /></td>
                                    <td className="text-end">
                                        <button type="button" className={styles.kebabButton} aria-label="Order actions">
                                            <FiMoreVertical size={18} />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
